import React from 'react';
import {
  InstantSearch,
  useConnector,
  useInstantSearch,
} from 'react-instantsearch';
import connectAutocomplete from 'instantsearch.js/es/connectors/autocomplete/connectAutocomplete.js';
import connectHits from 'instantsearch.js/es/connectors/hits/connectHits.js';
import connectPagination from 'instantsearch.js/es/connectors/pagination/connectPagination.js';
import connectRefinementList from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList.js';
import connectSearchBox from 'instantsearch.js/es/connectors/search-box/connectSearchBox.js';

function createConnector(connector) {
  return function wrapWithConnector(Component) {
    function ConnectedComponent(props) {
      const connectorProps = useConnector(connector, props);

      return <Component {...props} {...connectorProps} />;
    }

    ConnectedComponent.displayName = `InstantSearchCompat(${Component.displayName || Component.name || 'Component'})`;

    return ConnectedComponent;
  };
}

function connectStateResults(Component) {
  function ConnectedComponent(props) {
    const { results } = useInstantSearch();

    return <Component {...props} searchResults={results} />;
  }

  ConnectedComponent.displayName = `InstantSearchStateResults(${Component.displayName || Component.name || 'Component'})`;

  return ConnectedComponent;
}

const connectAutoComplete = createConnector(connectAutocomplete);
const connectHitsCompat = createConnector(connectHits);
const connectPaginationCompat = createConnector(connectPagination);
const connectRefinementListCompat = createConnector(connectRefinementList);
const connectSearchBoxCompat = createConnector(connectSearchBox);

export {
  InstantSearch,
  connectAutoComplete,
  connectHitsCompat as connectHits,
  connectPaginationCompat as connectPagination,
  connectRefinementListCompat as connectRefinementList,
  connectSearchBoxCompat as connectSearchBox,
  connectStateResults,
};
